import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/context/AuthContext";
import { NFProvider } from "@/context/NFContext";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import ColaboradorDashboard from "./pages/colaborador/Dashboard";
import NovaNF from "./pages/colaborador/NovaNF";
import MinhasNFs from "./pages/colaborador/MinhasNFs";
import DetalheNFColab from "./pages/colaborador/DetalheNF";
import RHDashboard from "./pages/rh/Dashboard";
import RHHeadcount from "./pages/rh/Headcount";
import RHListaNFs from "./pages/rh/ListaNFs";
import RHDetalheNF from "./pages/rh/DetalheNF";
import RHColaboradores from "./pages/rh/Colaboradores";
import RHTomadores from "./pages/rh/Tomadores";
import Perfil from "./pages/Perfil";
import RHDepartamentos from "./pages/rh/Departamentos";
import RHRelatorio from "./pages/rh/Relatorio";
import RHAuditoria from "./pages/rh/Auditoria";
import RHFolhas from "./pages/rh/Folhas";
import RHFolhaDetalhe from "./pages/rh/FolhaDetalhe";
import RHEmprestimos from "./pages/rh/Emprestimos";
import RHConfiguracoes from "./pages/rh/Configuracoes";
import RHBeneficios from "./pages/rh/Beneficios";
import RHBeneficioDetalhe from "./pages/rh/BeneficioDetalhe";
import RHBonificacoes from "./pages/rh/Bonificacoes";
import RHBonificacaoCompetencia from "./pages/rh/BonificacaoCompetencia";
import ColaboradorDemonstrativo from "./pages/colaborador/Demonstrativo";
import WorkspaceImportCallback from "./pages/WorkspaceImportCallback";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <NFProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/colaborador" element={<ColaboradorDashboard />} />
              <Route path="/colaborador/nova" element={<NovaNF />} />
              <Route path="/colaborador/notas" element={<MinhasNFs />} />
              <Route path="/colaborador/notas/:id" element={<DetalheNFColab />} />
              <Route path="/rh" element={<RHDashboard />} />
              <Route path="/rh/headcount" element={<RHHeadcount />} />
              <Route path="/rh/nova" element={<NovaNF />} />
              <Route path="/rh/notas" element={<RHListaNFs />} />
              <Route path="/rh/notas/:id" element={<RHDetalheNF />} />
              <Route path="/rh/colaboradores" element={<RHColaboradores />} />
              <Route path="/rh/tomadores" element={<RHTomadores />} />
              <Route path="/rh/departamentos" element={<RHDepartamentos />} />
              <Route path="/rh/relatorio" element={<RHRelatorio />} />
              <Route path="/rh/auditoria" element={<RHAuditoria />} />
              <Route path="/rh/folha" element={<RHFolhas />} />
              <Route path="/rh/folha/:id" element={<RHFolhaDetalhe />} />
              <Route path="/rh/emprestimos" element={<RHEmprestimos />} />
              <Route path="/rh/beneficios" element={<RHBeneficios />} />
              <Route path="/rh/beneficios/:id" element={<RHBeneficioDetalhe />} />
              <Route path="/rh/bonificacao" element={<RHBonificacoes />} />
              <Route path="/rh/bonificacao/:id" element={<RHBonificacaoCompetencia />} />
              <Route path="/rh/configuracoes" element={<RHConfiguracoes />} />
              <Route path="/colaborador/demonstrativo" element={<ColaboradorDemonstrativo />} />
              <Route
                path="/colaborador/demonstrativo/:competencia"
                element={<ColaboradorDemonstrativo />}
              />
              <Route path="/perfil" element={<Perfil />} />
              <Route path="/workspace-import/callback" element={<WorkspaceImportCallback />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </NFProvider>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
